import * as React from 'react'
import { Box, FlexGrid, Tabs as AlliumTabs } from '@telus-uds/components-web'
import {
  TypeTabNavigationWithoutUnresolvableLinksResponse,
  TypeTabNavigationLinkWithoutUnresolvableLinksResponse,
} from 'contentful-types'
import alloyEvents from '../../../utils/alloyAnalytics/tabs'

export type TabProps = {
  id: TypeTabNavigationLinkWithoutUnresolvableLinksResponse['sys']['id']
  linkText: TypeTabNavigationLinkWithoutUnresolvableLinksResponse['fields']['linkText']
  linkId: TypeTabNavigationLinkWithoutUnresolvableLinksResponse['fields']['linkId']
}

export type TabNavigationProps = {
  sysID: TypeTabNavigationWithoutUnresolvableLinksResponse['sys']['id']
  entryTitle: TypeTabNavigationWithoutUnresolvableLinksResponse['fields']['entryTitle']
  tabNavigationLinks?: TabProps[]
}

const TabNavigation = ({ sysID, entryTitle, tabNavigationLinks }: TabNavigationProps) => {
  return (
    <FlexGrid gutter={false}>
      <FlexGrid.Row>
        <FlexGrid.Col>
          <Box vertical={4}>
            <AlliumTabs
              items={tabNavigationLinks.map(({ linkId, linkText }) => {
                return {
                  label: linkText,
                  href: `#${linkId}`,
                  id: linkId,
                  onPress: () => alloyEvents.tabChange({ sysID, entryTitle, tabID: linkId }),
                }
              })}
            />
          </Box>
        </FlexGrid.Col>
      </FlexGrid.Row>
    </FlexGrid>
  )
}

export default TabNavigation
